import {
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DialogProps } from "../../types/Utils";
import FancyDialogActions from "./FancyDialogActions";
import { InvoiceActivity } from "../../services/invoices/InvoicesType";
import { formatNumber } from "./formatters";

const formatDateArray = (arr: number[]): string => {
  if (!arr || arr.length < 3) return "";
  const [y, m, d, h = 0, min = 0] = arr;
  return `${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}/${y} ${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
};

const AddOrUpdateInvoices = ({ data, cancelModal }: DialogProps) => {
  return (
    <>
      <DialogTitle id="alert-dialog-title" sx={{ pt: 4, px: 4, color: "primary.dark", fontWeight: 700 }}>
        Detalles de la factura
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: 0 }}>
        <Grid container columnSpacing={30} rowSpacing={10} sx={{ pt: 2, pb: 4, mt: 2 }}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Fecha de factura"
              value={formatDateArray(data?.createdAt ?? [])}
              size="small"
              disabled
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="N° de factura"
              value={data?.consecutiveNumber ?? ""}
              size="small"
              disabled
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Proveedor"
              value={data?.supplier?.name ?? ""}
              size="small"
              disabled
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Registrado por"
              value={data?.registeredBy ?? ""}
              size="small"
              disabled
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        <Divider sx={{ mb: 5, mt: 5 }} />

        <TableContainer>
          <Table size="small" aria-label="invoice-detail-lines-table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '90px' }}>Código</TableCell>
                <TableCell sx={{ width: '300px', minWidth: '220px' }}>Descripción</TableCell>
                <TableCell align="center" sx={{ width: '80px' }}>Cantidad</TableCell>
                <TableCell sx={{ width: '120px' }}>Unidad de medida</TableCell>
                <TableCell sx={{ width: '120px' }}>Codigo de producto</TableCell>
                <TableCell>Producto</TableCell>
                <TableCell align="right" sx={{ width: '120px' }}>Costo total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(data?.activities ?? []).map((act: InvoiceActivity, index: number) => (
                <TableRow key={index}>
                  <TableCell sx={{ width: '90px' }}>{act.ticketCode ?? "N/A"}</TableCell>
                  <TableCell sx={{ width: '300px', minWidth: '220px', whiteSpace: 'normal', wordBreak: 'break-word' }}>{act.ticketDescription ?? "N/A"}</TableCell>
                  <TableCell align="center" sx={{ width: '80px' }}>{act.incomingQuantity}</TableCell>
                  <TableCell sx={{ width: '120px' }}>{act.ticketMeasure ?? "N/A"}</TableCell>
                  <TableCell sx={{ width: '120px' }}>{act.productCode}</TableCell>
                  <TableCell>{act.productDescription}</TableCell>
                  <TableCell align="right" sx={{ width: '120px' }}>{formatNumber(act.cost ?? 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Grid container justifyContent="flex-end" alignItems="center" sx={{ mt: 3, pr: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 1 }}>
            Costo Total:
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {formatNumber(
              (data?.activities ?? []).reduce(
                (sum: number, act: InvoiceActivity) =>
                  sum + (act.cost ?? 0),
                0
              )
            )}
          </Typography>
        </Grid>
      </DialogContent>

      <FancyDialogActions
        handleAccept={cancelModal}
        cancelModal={cancelModal}
        textAcceptButton="Aceptar"
        textCancelButton="Volver"
      />
    </>
  );
};

export default AddOrUpdateInvoices;
